export default "__VITE_PUBLIC_ASSET__527a3cb5__"